import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../../../../../shared/shared.module';
import { CommentComponent } from './comment/comment.component';
import { ViewCommentsComponent } from './view-comments/view-comments.component';
import { PostManualAuditIssueCommentComponent } from './post-comment/post-manual-audit-issue-comment.component';
import { ManualAuditIssueCommentSectionComponent } from './manual-audit-issue-comment-section.component';
import { DeleteCommentComponent } from './delete-comment/delete-comment.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
    ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
  ],
  declarations: [
    CommentComponent,
    ViewCommentsComponent,
    PostManualAuditIssueCommentComponent,
    ManualAuditIssueCommentSectionComponent,
    DeleteCommentComponent,
  ],
  exports: [ManualAuditIssueCommentSectionComponent, ViewCommentsComponent],
})
export class CommentSectionModule {}
